import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import api from '../api/axios';
 
export default function RegisterDevice() {
  const [search, setSearch] = useState('');
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [devices, setDevices] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);

  useEffect(() => {
   fetchDevices();
  }, []);
 
  const normalizeText = (text) => {
    return text
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, ""); // quita acentos
  };
 
  const fetchDevices = async () => {
    try {
      setLoadingTable(true);
      const res = await api.get("/devices/list");
      setDevices(res.data.data)
      setFilteredDevices(res.data.data);
    
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingTable(false);
    }
  };
 
  useEffect(() => {
    const result = devices.filter(item =>
      normalizeText(item.tenant?.name)?.includes(normalizeText(search)) ||
      normalizeText(item.vehicle?.plate)?.includes(normalizeText(search)) ||
      normalizeText(item.registered_at)?.includes(normalizeText(search)) ||
      normalizeText(item.status)?.includes(normalizeText(search))
    );
    setFilteredDevices(result);
  }, [search, devices]);
 
  const columns = [
    { name: 'Empresa', selector: row => row.tenant?.name, sortable: true },
    { name: 'Vehículo', selector: row => row.vehicle?.plate, sortable: true },
    { name: 'Fecha registro',
      selector: row => {
      const d = new Date(row.registered_at);
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
    }, sortable: true },
    { 
      name: "Estado",
      cell: (row) => (
        <span
          className={`badge ${row.status === 'active' ? "bg-success" : "bg-danger"}`}
        >
          {row.status === 'active' ? "Activo" : "Inactivo"}
        </span>
      ),
    },
    
  ];
 
  return (
    <div className="mt-4">
      <DataTable
        title="Listado de dispositivos registrados"
        columns={columns}
        data={filteredDevices}
        pagination
        highlightOnHover
        responsive
        striped
        subHeader
        progressPending={loadingTable}
        progressComponent={
          <div className="text-center p-3">
            <div className="spinner-border text-primary"></div>
            <p>Cargando...</p>
          </div>
        }
        subHeaderComponent={
          <div className="d-flex justify-content-between w-100">
            <input
              type="text"
              className="form-control w-25"
              placeholder="Buscar..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        }
      />
    </div>
  );
}
 